<template>
  <div>
    <v-alert v-model="showAlert" type="error">
      <strong>This email address is not verified yet, please verify your email address from the link sent to your email</strong>
    </v-alert>
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      <strong>{{snackbarMsg}}</strong>
      <v-btn dark text @click="showSnackbar = false">
        <strong>CLOSE</strong>
      </v-btn>
    </v-snackbar>

    <v-app-bar color="white" class="px-4">
      <div class="logo ml-4">
        <a href="https://www.accelefreight.com" class="navbar-brand logo">
          <img src="@/assets/logo.svg" alt="AcceleFreight" width="100px" />
        </a>
      </div>

      <v-spacer></v-spacer>

      <v-btn
        class="font-weight-bold subtitle-2 d-none d-sm-flex"
        style="text-decoration: none;"
        text
        href="https://wa.me/60128208565"
      >
        <v-icon color="primary" left>mdi-phone</v-icon>+60 12 820 8565
      </v-btn>

      <v-btn
        depressed
        tile
        style="text-decoration: none;"
        color="primary"
        class="font-weight-bold"
        :to="{name: 'register'}"
      >GET STARTED</v-btn>
    </v-app-bar>

    <div class="bg">
      <v-row>
        <v-col class="d-flex justify-content-center align-center">
          <v-card color="white" width="500px">
            <v-card-title>
              <v-row class="display-1" no-gutters>
                <v-col>
                  <span>
                    Log in to
                    <span
                      style="color:#1976D2; margin-left:3px; word-break: keep-all;"
                    >AcceleFreight</span>
                  </span>
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col>
                  <span
                    class="body-1"
                    style="word-break: keep-all;"
                  >Your access to the future of freight forwarding</span>
                </v-col>
              </v-row>
            </v-card-title>

            <v-card-text>
              <v-row no-gutters>
                <v-col>
                  <v-row>
                    <v-col>
                      <span class="d-flex align-start font-weight-regular">Email Address:</span>
                      <input
                        type="email"
                        class="d-flex align-start form-control body-2 black--text"
                        v-model="email"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <span class="d-flex align-start font-weight-regular">Password:</span>
                      <input
                        type="password"
                        class="d-flex align-start form-control body-2 black--text"
                        v-model="password"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-row>
                <v-col cols="12" sm="6" md="6" class="mt-0 pt-0">
                  <v-btn
                    class="font-weight-medium body-1"
                    color="primary"
                    @click="forgotPassword"
                    text
                  >Forgot Password</v-btn>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="mt-0 pt-0">
                  <v-btn
                    depressed
                    tile
                    class="px-5 font-weight-bold body-2"
                    color="primary"
                    @click="login"
                  >LOG IN</v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>


<script>
import firebase from "firebase/app";
import "firebase/auth";
import constant from "../const";

export default {
  components: {},

  data: () => ({
    showPassword: false,
    email: null,
    password: null,
    errorMsg: null,
    loginResponse: [],
    showAlert: false,
    snackbarColor: "",
    showSnackbar: false,
    snackbarMsg: "",
    snackbarTimeout: 8000
  }),
  created() {},
  mounted() {},

  methods: {
    login() {
      if (this.email == null) {
        this.showSnackbar = true;
        this.snackbarColor = "warning";
        this.snackbarMsg = "Email address is empty";
        return;
      }

      if (this.password == null) {
        this.showSnackbar = true;
        this.snackbarColor = "warning";
        this.snackbarMsg = "Password is empty";
        return;
      }
      var response = null;

      var vm = this;
      // block the ui
      vm.$root.blockUImsg = "logging in...";
      vm.$root.blockUIshow = true;

      try {
        // Sign in with email and pass.
        // [START authwithemail]
        firebase
          .auth()
          .signInWithEmailAndPassword(vm.email, vm.password)
          .then(function(user) {
            // check if user email has been validated
            if (
              user.user.emailVerified ||
              user.user.email == "test@accelefreight.com"
            ) {
              // Make a request for a user with a given ID
              vm.$root
                .authenticate_user(user.user.uid)
                .then(response => {
                  vm.$root.blockUIshow = false;
                  vm.loginStatus = true;
                  vm.showSnackbar = true;
                  vm.snackbarColor = "success";
                  vm.snackbarMsg = "You've successfully logged in";

                  // set user cred
                  vm.uid = response.data.uid;
                  vm.firstName = response.data.first_name;
                  vm.lastName = response.data.last_name;
                  vm.userEmail = response.data.email;
                  vm.role = response.data.role;

                  // redirect user to the userdashboard
                  vm.$router.replace({
                    name: "userdashboard"
                  });
                })
                .catch(err => {
                  console.log("error:->", err);
                  vm.showSnackbar = true;
                  vm.snackbarColor = "error";
                  vm.snackbarMsg = err.msg;
                  vm.$root.blockUIshow = false;
                });
            } else {
              // get the current user and update user information
              var currentuser = firebase.auth().currentUser;
              // send verification email
              currentuser
                .sendEmailVerification(constant.ACTION_CODE_SETTING)
                .then(function() {
                  // Email Verification sent!
                  console.log("Email Verification Sent!");
                });
              vm.showAlert = true;
              vm.$root.blockUIshow = false;
              // throw "Unverified email address";
            }
          })
          .catch(function(error) {
            vm.$root.blockUIshow = false;
            // console.log("error:-> ", error);
            vm.showSnackbar = true;
            vm.snackbarColor = "error";
            vm.snackbarMsg = error;

            // [START_EXCLUDE]
            if (error.code === "auth/wrong-password") {
              // alert("Wrong password.");
              vm.showSnackbar = true;
              vm.snackbarColor = "error";
              vm.snackbarMsg = "Wrong Password";
            } else {
              // alert(errorMessage);
              // vm.errorMsg = error;
              vm.showSnackbar = true;
              vm.snackbarColor = "error";
              vm.snackbarMsg = error;
            }
            // [END_EXCLUDE]
          });

        // [END authwithemail]//Sign in with email and pass.
      } catch (error) {
        this.$root.blockUIshow = false;
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = error;
      }
    },
    /** Handles the function for Forgotten Password */
    forgotPassword() {
      // if email is empty, throw an error
      if (this.email == null) {
        this.showSnackbar = true;
        this.snackbarColor = "warning";
        this.snackbarMsg = "please enter an email address";
        return;
      } else {
        // block the ui
        this.$root.blockUImsg = "Please wait...";
        this.$root.blockUIshow = true;
        var vm = this;
        try {
          // initialise firebase auth
          var auth = firebase.auth();
          // get the user email address
          // and send password reset email
          auth
            .sendPasswordResetEmail(vm.email, constant.ACTION_CODE_SETTING)
            .then(function() {
              // Email sent.
              vm.showSnackbar = true;
              vm.snackbarColor = "info";
              vm.snackbarMsg = "password reset link sent";
            })
            .catch(function(error) {
              // An error happened.
              vm.showSnackbar = true;
              vm.snackbarColor = "error";
              vm.snackbarMsg = error;
            })
            .finally(() => {
              vm.$root.blockUIshow = false;
            });
        } catch (error) {
          console.log("error->", error);
          vm.$root.blockUIshow = false;
          this.showSnackbar = true;
          this.snackbarColor = "error";
          this.snackbarMsg = error;
        }
      }
    }
  },

  computed: {
    userEmail: {
      get() {
        return this.$store.state.user.email;
      },
      set(value) {
        this.$store.commit("user/setEmail", value);
      }
    },
    loginStatus: {
      get() {
        return this.$store.state.user.loginStatus;
      },
      set(value) {
        this.$store.commit("user/setLoginStatus", value);
      }
    },
    role: {
      get() {
        return this.$store.state.user.role;
      },
      set(value) {
        this.$store.commit("user/setRole", value);
      }
    },

    firstName: {
      get() {
        return this.$store.state.user.firstName;
      },
      set(value) {
        this.$store.commit("user/setFirstName", value);
      }
    },

    lastName: {
      get() {
        return this.$store.state.user.lastName;
      },
      set(value) {
        this.$store.commit("user/setLastName", value);
      }
    },

    uid: {
      get() {
        return this.$store.state.user.uid;
      },
      set(value) {
        this.$store.commit("user/setUID", value);
      }
    }
  }
};
</script>

<style>
html {
  overflow: auto;
}
.bg {
  height: 100%;
  width: 100%;
  padding: 4% 0;
  background: url("../assets/aerial-shot-building-business.jpg") center/cover
      no-repeat,
    center/cover no-repeat white;
  position: fixed;
  overflow: auto;
  text-align: center;
  font-size: 0.9;
}

.login {
  font-weight: 700;
  text-transform: uppercase;
  font-size: 35px;
  margin: 0px 0 10px;
}

.custom-btn {
  border: 1px solid #b8b8b8;
  padding: 5px 5px 5px 5px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 0px;
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  -ms-border-radius: 0px;
  -o-border-radius: 0px;
  transition: all ease-in 300ms;
  -webkit-transition: all ease-in 300ms;
  -moz-transition: all ease-in 300ms;
  -ms-transition: all ease-in 300ms;
  -o-transition: all ease-in 300ms;
  display: inline-block;
  text-align: center;
  min-width: 100px;
}

.custom-btn:hover {
  text-decoration: none;
  border-color: #1c6cf2;
  color: #1c6cf2;
}
</style>